// Treści pytań/odpowiedzi przychodzą z edytora jako HTML. Czyścimy do czystego tekstu
// (odpowiednik iOS `String.strippedHTML` i Android `String.stripHtml`) i auto-linkujemy URL-e.
// WAŻNE: stripujemy WSZYSTKIE tagi (nie tylko gołe <p>/<a>), bo treść bywa np. `<p dir="ltr">`,
// `<br>`, `<strong>`, `<ul><li>` — wcześniej renderowały się dosłownie.

const decodeEntities = (text: string): string =>
  text
    .replaceAll("&nbsp;", " ")
    .replaceAll("&amp;", "&")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&quot;", '"')
    .replaceAll("&#39;", "'")
    .replaceAll("&apos;", "'");

export const htmlToPlainText = (html: string): string => {
  if (!html) return "";
  const withBreaks = html
    // bloki/łamania → spacja, żeby nie sklejać słów z sąsiednich akapitów/linii
    .replaceAll(/<\/(p|div|li|h[1-6]|tr)>/gi, " ")
    .replaceAll(/<br\s*\/?>/gi, " ");
  const withoutTags = withBreaks.replaceAll(/<[^>]+>/g, "");
  return decodeEntities(withoutTags).replaceAll(/\s+/g, " ").trim();
};

export const convertHtmlToText = (html: string) => {
  const text = htmlToPlainText(html ?? "");
  const splitHtml = text.split(/(https?:\/\/[^\s]+)/g);

  const finalElementsArray = splitHtml.map((part, index) => {
    if (index % 2 === 0) {
      return <span key={index}>{part}</span>;
    } else {
      return (
        <a key={index} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
  });

  return finalElementsArray;
};
